import React from 'react';
import "./gallery.css";

export function Gallery({ images = [] }){
  return (
    <div className='gallery'
      style={{
        /* 3 oszlopot hoz létre alapértelmezetten */
        columnCount: 3,
        /* Az oszlopok közötti távolság */
        columnGap: '1em',
      }}
    >
      {images.map((src, index) => (
        <div
          key={index}
          style={{
            /* Fontos, hogy a képek ne törjenek meg oszlophatáron */
            breakInside: 'avoid',         // Chrome, Safari
            WebkitColumnBreakInside: 'avoid',  // Régebbi Safari
            MozColumnBreakInside: 'avoid',     // Firefox
            marginBottom: '1em',
          }}
        >
          <img
            src={src}
            alt={`Kép #${index}`}
            style={{
              width: '100%',
              display: 'block',
              borderRadius: '4px', 
            }}
          />
        </div>
      ))}
    </div>
  );
};

